import React from "react";
import { useTranslation } from "react-i18next";

import { ToggleInput } from "@common/toggleInput";
import { Context } from "../../context";
import { Icon } from "./icon";
import { Props } from "./types";
import styles from "./styles.scss";

function WorkloadsToggle(_: Props) {
  const { t } = useTranslation();
  const { areWorkloadsToggled, toggleWorkloads } = React.useContext(Context);

  return (
    <div className={styles.workloadsToggle} onClick={toggleWorkloads}>
      <Icon className={styles.icon} />
      <p className={styles.text}>{t("gantt.workLoadsToggle")}</p>
      <ToggleInput isToggled={areWorkloadsToggled} />
    </div>
  );
}

export { WorkloadsToggle };
